import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AbstractAuthorizationService } from 'src/app/moov-common/services/authorization/authorization.abstract.service';
import { InternalEventsManagerService } from 'src/app/moov-common/services/internal-events-manager/internal-events-manager.service';
import { Auth0OrighinEnum, EngagementLevelEnum, PersonalUserData, PreferredEngagementCahnnelEnum } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { TranslateService } from '@ngx-translate/core';
import { GenderPipe } from 'src/app/moov-common/pipes/gender.pipe';
import { LocalStorageService } from 'src/app/moov-common/services/localStorage';
import { LocalStorageKeys } from 'src/app/moov-common/services/localStorage/local-storage.enum';
import { VerifyPhoneNumberComponent } from '../../verify-phone-number/verify-phone-number.component';
import { MatDialog } from '@angular/material/dialog';
import { MsalService } from '@azure/msal-angular';
import { ActionConfirmationDialogComponent } from 'src/app/moov-common/components/action-confirmation-dialog/action-confirmation-dialog.component';
import { ClaroEvents } from 'src/app/moov-common/services/google-analytics/analytics.enum';
import { EnvConfigService } from 'src/app/moov-common/services/env-config/env-config.service';
import { EnvConfigKeys } from 'src/app/moov-common/services/env-config/env-keys';
import { FeatureID } from 'src/app/moov-common/enum/feature.enum';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent extends BaseComponent
 implements OnInit {

  isUpdating: boolean = false;
  userDetails: PersonalUserData;
  selectedGender : number;
  selectedLocale : string;
  isChangingPassword : boolean = false;
  hidePassword: boolean = false;
  userDataUpdated: boolean = false;
  userPasswordUpdated : boolean = false;;
  oldPassword: string = "";
  newPassword: string = "";
  errMessage: string = "";
  phoneNumber: string = "";
  phoneNumberInternationalCode : string = "";
  isPresentFullHierarchy: boolean = false;
  isEngageWithUser :boolean = false;
  isSendQustioner : boolean = false;
  isPasswordIssues : boolean = false;
  isAllowShareMotivations : boolean = false;
  preferredEngagementChannel : number = 0;
  shouldVerifyPhoneNumber : boolean = false;
  userVerifiedPhoneNumberOverride : boolean = false;
  shouldSaveBeforVerification: boolean = false;
  fullPhoneNumber : string = "";
  isUserConnectedToMicrosoftAccount : boolean = false;
  userPrincipalName : string = "";
  isAllowShareCalendar : boolean = false;
  isAuth0DataLoading : boolean = false;
  auth0_msft_enabled : boolean = false;

  constructor(private readonly personalUserService:AbstractPersonalUserDataService, 
              private readonly authService: AbstractAuthorizationService, 
              public router : Router,
              private internalEventService: InternalEventsManagerService,
              private translate: TranslateService,
              private genderSerivce: GenderPipe,
              private localStorage: LocalStorageService,
              public dialog: MatDialog,
              private msalService: MsalService,
              private envConfigService: EnvConfigService) {
    super();

    this.userDataUpdated = false;
    this.isChangingPassword = false; 
    this.hidePassword = true;
    this.userPasswordUpdated = false;
   }

  ngOnInit(): void {
    super.ngOnInit();
    
    if (this.user){
      this.userDetails = this.user;

      if (this.userDetails.gender){
        this.selectedGender = this.userDetails.gender;
      }

      if (this.userDetails.locale){
          this.selectedLocale = this.userDetails.locale.toString();  
      }

      if (this.userDetails.presentFullHierarchy){
        this.isPresentFullHierarchy = this.userDetails.presentFullHierarchy;
      }

      if (this.userDetails.phoneNumber != "" && !this.userDetails.isPhoneNumberVerified){
        this.shouldVerifyPhoneNumber = true;
      }

      this.shouldSaveBeforVerification = false;

      // console.log (`in UP onInit this.userDetails.engagementLevel is ${this.userDetails.engagementLevel}`);
      this.isEngageWithUser = (this.userDetails.engagementLevel != EngagementLevelEnum.NONE);

      this.isSendQustioner =  this.userDetails.shouldGetQuestioners;
      this.isAllowShareMotivations = this.userDetails.allowShareMotivations;
      
      this.isAllowShareCalendar = false;
      if (this.userDetails.allowShareCalendar !== undefined){
        // saved user details might be missing the share calendar flag
        this.isAllowShareCalendar = this.userDetails.allowShareCalendar;
      }

      // console.log(`in UP onInit preferred channel is ${this.userDetails.preferredEngagementCahnnel}`);
      this.preferredEngagementChannel = this.userDetails.preferredEngagementCahnnel;
      
      if (this.userDetails.phoneNumber != ''){
        this.phoneNumberInternationalCode = this.userDetails.phoneNumberCountryCode;

        // present the phone number wo the international code
        this.phoneNumber = this.userDetails.phoneNumber.substring(this.userDetails.phoneNumberCountryCode.length);
      }

      this.verifyFeatures();

      this.internalEventService.auth0LoginSuccess.subscribe(() => {
        this.getAuth0StatusDetails();
      });
    }
  }

  verifyFeatures(): void{
    this.personalUserDataServiceForBaseClass.verifyFeature(FeatureID.auth0_msft).subscribe((isEnabled: boolean) => {
      this.auth0_msft_enabled = isEnabled;

      if (this.auth0_msft_enabled){
        this.getAuth0StatusDetails();
      }
    });
  }

  microsoftDisconnet(): void{
    const dialogRef = this.dialog.open(ActionConfirmationDialogComponent, {
      data:{},
      height: 'fit-content',
      width: (this.isMobileView? '90%':'30%'),                                                   
      direction: this.isRTL ? 'rtl' : 'ltr'});

    // Pass the chat name as an input
    dialogRef.componentInstance.title = this.translate.instant('personal.microsoftLogin_disconnectDialogTitle');
    dialogRef.componentInstance.message = this.translate.instant(this.genderSerivce.transform('personal.microsoftLogin_disconnectDialogMessage'));
    dialogRef.componentInstance.confirmButtonText = this.translate.instant('personal.microsoftLogin_disconnectDialogConfirmButton');
    dialogRef.componentInstance.cancelButtonText = this.translate.instant('personal.microsoftLogin_disconnectDialogCancelButton');

    // Subscribe to the outputs
    dialogRef.componentInstance.confirm.subscribe(() => {
    // Perform the deletion logic here
    // console.log('Deletion selected');
      dialogRef.close();

      this.personalUserService.deleteUserAuth0Details(Auth0OrighinEnum.MICROSOFT).subscribe(response => {
        this.analytics.sendClaroEvent(ClaroEvents.MicrosoftLogin_disconnect);
        this.getAuth0StatusDetails();
      });
    });    

    dialogRef.componentInstance.cancel.subscribe(() => {
    // Handle cancellation if needed
    // console.log('Deletion canceled');
    dialogRef.close();
    });
}    

  getAuth0StatusDetails (): void{
    this.isAuth0DataLoading = true;
    // console.log(`getAuth0StatusDetails - this.user is ${JSON.stringify(this.user)}`);
    this.personalUserService.getUserAuth0RedactedData(Auth0OrighinEnum.MICROSOFT).subscribe(data => {
      if (data){
        this.isUserConnectedToMicrosoftAccount = data.origin == Auth0OrighinEnum.MICROSOFT;
        this.userPrincipalName = data.upn;
      }
      else{
        this.isUserConnectedToMicrosoftAccount = false;
        this.userPrincipalName = "";
      }

      this.isAuth0DataLoading = false;
    });
  }

  microsoftApproveCalendar(): void{
    this.isAllowShareCalendar = true;
    this.updateUserDetails();
  }

  numericOnly(event : KeyboardEvent ): boolean {
    if (event.key && !event.key.match(/^\d$/)) {
       // If the key pressed is not a digit, prevent the default action
      event.preventDefault();
      return false;
    }
    return true;
  }

  verifyNumericInput(event: Event): void{
      const inputElement = event.target as HTMLInputElement; // Cast the event target to HTMLInputElement
      const initialValue = inputElement.value;
      inputElement.value = initialValue.replace(/[^0-9]*/g, ''); // Remove non-numeric characters
      if (initialValue !== inputElement.value) {
        event.stopPropagation();
      }
  }

  phoneNumberChanged(event: Event):void{
    this.verifyNumericInput(event);

    // once handling this event is done, verify if the phone number has changed
    setTimeout(() => {
      // remove leading zeros:
      let internationalCodeNoLZ: string = this.phoneNumberInternationalCode != "" ? parseInt(this.phoneNumberInternationalCode, 10).toString() : "";
      let phoneNumberNoLZ: string = this.phoneNumber != "" ? parseInt(this.phoneNumber, 10).toString() : "";

      this.fullPhoneNumber = internationalCodeNoLZ + phoneNumberNoLZ;
      
      if (this.user?.phoneNumber != this.fullPhoneNumber){
        this.shouldSaveBeforVerification = true;
      }     
      else{
        this.shouldSaveBeforVerification = false;
      }
    }, 0);
  }

  getLocaleForPresentation (locale: string): string{
    if (locale == "en-US"){
      return "English (US)";
    }
    else{
      // locale == "he-IL"
      return "Hebrew (IL)";
    }
  }

  updateUserDetails (): void{
    // check validity - if the user chose to engage via WA - verify that there that a phone number was added.
    if (this.preferredEngagementChannel == PreferredEngagementCahnnelEnum.WHATSAPP && this.phoneNumber == ""){
      this.errMessage = this.translate.instant(this.genderSerivce.transform('personal.error_preferredEngagementChannel'))
      return;
    }
    else{
      this.errMessage = "";
    }

    if (this.phoneNumberInternationalCode != "" && this.phoneNumber == "" ||
        this.phoneNumberInternationalCode == "" && this.phoneNumber != ""){
          // one part of the phone number is configured but the other is not
          this.errMessage = this.translate.instant('personal.error_phoneNumberIsNotComplete');
          return;
        }
    else{
        this.errMessage = "";
    }

    let engagementLevel = EngagementLevelEnum.NONE;
    // currently only support in full or none option for engagement level
    if (this.isEngageWithUser){
      engagementLevel = EngagementLevelEnum.FULL;
    }


    if (this.userDetails.engagementLevel == EngagementLevelEnum.FULL && !this.isEngageWithUser){
      // User have unsubscribed
      this.analytics.userEngagementUnsubscribeEvent();
    }

    this.isUpdating = true;
    this.personalUserService.setUserDetails(this.selectedLocale,
                                            this.selectedGender, 
                                            this.phoneNumber, 
                                            this.phoneNumberInternationalCode, 
                                            this.isPresentFullHierarchy, 
                                            engagementLevel, 
                                            this.preferredEngagementChannel, 
                                            this.isSendQustioner, 
                                            this.isAllowShareMotivations, 
                                            this.isAllowShareCalendar).subscribe(result => {
      this.internalEventService.reloadUserData.emit("");
      this.authService.updateLoggedInUserToken().subscribe(()=> {
        this.localStorage.write(LocalStorageKeys.userSelectedLocale, this.getLocale());
        window.location.reload();
        this.isUpdating = false;
      });
      this.isUpdating = false;
    });
  }

  updateUserPassword(): void{
    this.isChangingPassword = true;
    this.isPasswordIssues = false;
  }

  cancelUpdatePassdword(): void{
    this.isChangingPassword = false;
    this.isPasswordIssues = false;
  }

  submitUserPassword(): void{
    this.isPasswordIssues = false;
    this.errMessage = "";
    if (this.newPassword.length < 8){
      this.errMessage = this.translate.instant("personal.newPasswordTooShort");
    }
    else{
      this.isUpdating = true;
      this.personalUserService.updateUserPassword(this.oldPassword,this.newPassword).subscribe(response => {
        
        // console.log(`in submitUserPassword receivied response status as ${response.status}`);

        if (response.status === 200){
          // console.log("in submitUserPassword receivied response status as 200");
          this.errMessage = "";
          this.isChangingPassword = false;
          this.userPasswordUpdated = true;   
        }else {
          if (response.status === 401) {
            // console.log("in submitUserPassword receivied response status as 401");
            this.errMessage = this.translate.instant(this.genderSerivce.transform("personal.updatePasswordIssues"));
          }
          else{
            console.log(`in submitUserPassword receivied response status as ${response.status}`);
          }
        }
        this.isUpdating = false;
      }, error => {
          if (error.status === 401) {
            // console.log("in submitUserPassword receivied error status as 401");
            this.errMessage = this.translate.instant(this.genderSerivce.transform("personal.updatePasswordIssues"));
          }
          else{
            // console.log(`in submitUserPassword receivied error status as ${error.status}`);
          }
          this.isUpdating = false;
      });
    }
  }

  microsoftLogin(): void{
    this.msalService.loginRedirect({
      scopes: [
        'openid',            // for OpenID Connect
        'profile',           // basic profile info
        'offline_access',    // to get a refresh token
        'Calendars.Read'
      ],
      // The OBO scope belongs to a different resource than Graph, so it cannot share the scopes
      // array - a token is issued for one resource only. Consenting to it here is what lets
      // acquireTokenSilent later obtain it without a second interactive round trip.
      extraScopesToConsent: [
        `api://${this.envConfigService.get(EnvConfigKeys.auth0ClientId)}/OBO`
      ],
      state: `claroUserId_${this.user!.id}`
    });
  }

  verifyPhoneNumber(): void {
    // First verify the phone number is saved - if not, ask the user to save first.

    let dialogRef = this.dialog.open(VerifyPhoneNumberComponent, {
      height: 'fit-content',
      width: 'fit-content',
      panelClass: 'claro-custom-dialog',
      data: {} 
    });

    dialogRef.afterClosed().subscribe(isVerified => {
      // console.log(`UP verifyPhoneNumber isVerified is ${isVerified}`);
        this.userVerifiedPhoneNumberOverride = isVerified;
    });
  }
}
